/**
 * DO NOT EDIT THIS FILE!
 * This file is auto generated by "grunt build-verifone-actions-names" to help with development.
 *
 * This is a list of all the possible actions extracted from all integration types
 * We can use these in code instead of strings.
 * Beware that an action might not exist for the integration type in use! Refer to the separate action lists
 * to see what is possible for that integration type.
 */
const VerifoneActionNames = Object.freeze({
    CONTINUE_TRANSACTION: 'CONTINUE_TRANSACTION',
    CONFIRM_SIGNATURE: 'CONFIRM_SIGNATURE',
    REJECT_SIGNATURE: 'REJECT_SIGNATURE',
    REPRINT_RECEIPT: 'REPRINT_RECEIPT',
    VOICE_REFERRAL_AUTHORISED: 'VOICE_REFERRAL_AUTHORISED',
    VOICE_REFERRAL_REJECTED: 'VOICE_REFERRAL_REJECTED',
    CANCEL_TRANSACTION: 'CANCEL_TRANSACTION',
    CHANGE_CARD: 'CHANGE_CARD',
    CONFIRM_AUTH_CODE: 'CONFIRM_AUTH_CODE',
    REJECT_AUTH_CODE: 'REJECT_AUTH_CODE',
    RETRY_DEVICE: 'RETRY_DEVICE',
    CASHBACK_REQUIRED: 'CASHBACK_REQUIRED',
    CASHBACK_NOT_REQUIRED: 'CASHBACK_NOT_REQUIRED',
    REPLACE_ACCOUNT: 'REPLACE_ACCOUNT',
    CANCEL_REPLACE_ACCOUNT: 'CANCEL_REPLACE_ACCOUNT',
    ACCOUNT_ON_FILE_REGISTRATION_REQUIRED: 'ACCOUNT_ON_FILE_REGISTRATION_REQUIRED',
    ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED: 'ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED',
    ATTEMPT_TO_RECONNECT: 'ATTEMPT_TO_RECONNECT',
    GO_OFFLINE: 'GO_OFFLINE',
    NO_TRANSACTION_VALUE_UPDATE_REQUIRED: 'NO_TRANSACTION_VALUE_UPDATE_REQUIRED',
    TRANSACTION_VALUE_UPDATE_REQUIRED: 'TRANSACTION_VALUE_UPDATE_REQUIRED',
    MERCHANT_REFERENCE_ENTERED: 'MERCHANT_REFERENCE_ENTERED',
    ACCEPT_CUSTOMER_RECEIPT: 'ACCEPT_CUSTOMER_RECEIPT',
    REJECT_CUSTOMER_RECEIPT: 'REJECT_CUSTOMER_RECEIPT',
    BYPASS_PIN: 'BYPASS_PIN',
    ALTERNATE_PAYMENT: 'ALTERNATE_PAYMENT',
    CHARGE_AUTH_CODE: 'CHARGE_AUTH_CODE',
    REVERSE_UAT_ICC_TXN: 'REVERSE_UAT_ICC_TXN',
    CONTINUE_WITHOUT_DEVICE: 'CONTINUE_WITHOUT_DEVICE',
    ABORT_DEVICE_CONNECTIVITY: 'ABORT_DEVICE_CONNECTIVITY',
    RETRY_DOWNLOAD: 'RETRY_DOWNLOAD',
    CANCEL_DOWNLOAD: 'CANCEL_DOWNLOAD',
    RESTART: 'RESTART',
    ACCEPT_UNSAFE_DOWNLOAD: 'ACCEPT_UNSAFE_DOWNLOAD',
    REJECT_UNSAFE_DOWNLOAD: 'REJECT_UNSAFE_DOWNLOAD',
    SELECT_PAYPOINT_ACCOUNT: 'SELECT_PAYPOINT_ACCOUNT',
    SELECT_PAYPOINT_OPTION: 'SELECT_PAYPOINT_OPTION',
    RETRY_PAYPOINT_CONFIRMATION: 'RETRY_PAYPOINT_CONFIRMATION',
    CANCEL_PAYPOINT_CONFIRMATION: 'CANCEL_PAYPOINT_CONFIRMATION',
    ACCEPT_LICENCE_KEY: 'ACCEPT_LICENCE_KEY',
    REJECT_LICENCE_KEY: 'REJECT_LICENCE_KEY',
    CANCEL_LICENCE_KEY_VERIFICATION: 'CANCEL_LICENCE_KEY_VERIFICATION',
    CONTINUE_LICENCE_KEY_VERIFICATION: 'CONTINUE_LICENCE_KEY_VERIFICATION',
    CONFIRM_PARK_RETAIL_GIFT_TRANSACTION: 'CONFIRM_PARK_RETAIL_GIFT_TRANSACTION',
    REVERSE_PARK_RETAIL_GIFT_TRANSACTION: 'REVERSE_PARK_RETAIL_GIFT_TRANSACTION',
    CANCEL_GET_CARD_DETAILS: 'CANCEL_GET_CARD_DETAILS',
    MERCHANT_CURRENCY_REQUIRED: 'MERCHANT_CURRENCY_REQUIRED',
    CARDHOLDER_CURRENCY_REQUIRED: 'CARDHOLDER_CURRENCY_REQUIRED',
    SUPPLY_IVR_DETAILS: 'SUPPLY_IVR_DETAILS',
    REJECT_IVR: 'REJECT_IVR',
    PRINT_SHOP_COPY_RECEIPT: 'PRINT_SHOP_COPY_RECEIPT',
    CANCEL_SHOP_COPY_RECEIPT: 'CANCEL_SHOP_COPY_RECEIPT',
    SUPPLY_STAN: 'SUPPLY_STAN',
    ACCEPT_PART_PAYMENT: 'ACCEPT_PART_PAYMENT',
    REJECT_PART_PAYMENT: 'REJECT_PART_PAYMENT',
    FURTHER_PAYMENT_REQUIRED: 'FURTHER_PAYMENT_REQUIRED',
    NO_FURTHER_PAYMENT_REQUIRED: 'NO_FURTHER_PAYMENT_REQUIRED',
});

module.exports = VerifoneActionNames;
